module.exports = __webpack_public_path__ + "img/checkmark.4a63bc68.svg";